export const isPathMatching = (useLocation, language) => {
  return useLocation.pathname === `/${language}`;
  //`/${language.toLowerCase()}`;
};
